export class BaseError<TData extends object | undefined = Record<string, unknown>> extends Error {
  /** Underlying cause, if any (e.g. Axios error, Viem error) */
  public readonly cause?: unknown;
  /** Additional contextual data for the error */
  public readonly data?: TData;

  constructor(message: string, options: { cause?: unknown; data?: TData } = {} as any) {
    super(message, { cause: options.cause });
    this.name = new.target.name;
    this.cause = options.cause;
    this.data = options.data;

    // Fix prototype chain when targeting ES5
    Object.setPrototypeOf(this, new.target.prototype);

    // Capture stack trace in V8 environments
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, new.target);
    }
  }
}
